import { Component, OnInit ,Input, Output,EventEmitter} from '@angular/core';
import { FileService } from 'projects/services/src/app/API/document/file.service';
import { Helpers } from 'projects/training-calendar/src/app/helpers';

@Component({
  selector: 'app-photo-slide-show',
  templateUrl: './photo-slide-show.component.html',
  styleUrls: ['./photo-slide-show.component.css']
})
export class PhotoSlideShowComponent implements OnInit {
  @Input() buttonText = 'View Photos';
	@Input() Photographs:any[];
	@Input() photoUploadedBy: any=[];
  Photographurl:any[]=[];
	showSliderPic: boolean = false;
	showimages: any = [];
    uploadedBy: any;
  constructor(private fileDownload: FileService) { }

  ngOnInit() {
	if (this.photoUploadedBy.length !== 0) {
		  this.uploadedBy = this.photoUploadedBy;
	}
  }
	// getImageSliderView() {
	// 	/*_getS3Urls() method wil accept array of strings as arguement*/
	// 	this.Photographs.map(data => {
	// 		if (this.Photographs) {
	// 			this._getS3Urls(this.Photographs).then(a => {
	// 				this.showimages = a;
	// 				this.showSliderPic = true;
	// 			})
	// 			if (data.PhotographUrl) {
	// 				this.Photographurl.push(data.PhotographUrl);
	// 				this._getS3Urls(this.Photographurl).then(a => {
	// 					this.showimages = a;
	// 					this.showSliderPic = true;
	// 				})
	// 			}

	// 		}

	// 	})
	// }
	 getImageSliderView() {
	 	this._getS3Urls(this.Photographs).then(a => {
	 		this.showimages = a;
	 		this.showSliderPic = true;
		})
	 }
	private _getS3Urls(policyUrls) {
		if (policyUrls) {
			const s3Urls = [];
			for (const policyUrl of policyUrls) {
				if (!policyUrl) {
					s3Urls.push(this._fakePromise(policyUrl))
					continue;
				}
				s3Urls.push(this._putS3Url(policyUrl));
			}
			console.log(s3Urls);
			return Promise.all(s3Urls);
		}
	}

	private _fakePromise(data) {
		return new Promise((resolve, reject) => {
			return resolve(data);
		})
	}

	private _putS3Url(policy_key) {
		return new Promise((resolve, reject) => {
			this.fileDownload.getImageURL(policy_key).subscribe(S3URL => {

				return resolve(S3URL);
			}, err => {
				return reject(err);
			});
		})
	}


}
